module.exports = __webpack_public_path__ + "img/vegetable-carrots-190x100.d5cee3c1.jpg";